export const zipCodeRegEx = RegExp(/^\d{5}([-]|\s*)?(\d{4})?$/gm);
export const emailRegEx = RegExp(/([A-Za-z0-9]+[.-_])*[A-Za-z0-9]+(@[A-Za-z0-9-]{0,63})+(\.[A-Za-z]{2,63})/);
export const orgNameRegex = RegExp(/^[a-zA-Z0-9-\- ]+$/);
export const websiteRegex = RegExp(/^(www.)?([a-z0-9]{0,63})\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/g);
export const phoneRegEx = RegExp(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im);

export const isoDateRegex = RegExp(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)$/);

export const passwordRegEx = RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/);

export const noSpecialCharactersRegEx = RegExp(/^[a-zA-Z0-9_\-.]*$/);
